import { call, put, takeEvery } from 'redux-saga/effects'
import restClient from 'restClient'

const restClientInstance = restClient(window.API_ROOT + '/api')

export const FETCH_OVERDUE_STATUS = 'FETCH_OVERDUE_STATUS'
export const FETCH_OVERDUE_STATUS_SUCCESS = 'FETCH_OVERDUE_STATUS_SUCCESS'
export const FETCH_OVERDUE_STATUS_FAILURE = 'FETCH_OVERDUE_STATUS_FAILURE'
export const SET_OVERDUE_CACHE = 'SET_OVERDUE_CACHE'

export const fetchOverdueStatus = (orgId: string) => ({
  type: FETCH_OVERDUE_STATUS,
  payload: { orgId },
})

export const fetchOverdueStatusSuccess = (hasOverdue: boolean) => ({
  type: FETCH_OVERDUE_STATUS_SUCCESS,
  payload: { hasOverdue },
})

export const fetchOverdueStatusFailure = (error: any) => ({
  type: FETCH_OVERDUE_STATUS_FAILURE,
  payload: { error },
})

export const setOverdueCache = (hasOverdue: boolean, timestamp: number) => ({
  type: SET_OVERDUE_CACHE,
  payload: { hasOverdue, timestamp },
})

export interface OverdueActionsState {
  hasOverdue: boolean
  isLoading: boolean
  error: any
  lastFetched: number | null
}

const initialState: OverdueActionsState = {
  hasOverdue: false,
  isLoading: false,
  error: null,
  lastFetched: null,
}

export default function overdueActionsReducer(state = initialState, action: any): OverdueActionsState {
  switch (action.type) {
    case FETCH_OVERDUE_STATUS:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case FETCH_OVERDUE_STATUS_SUCCESS:
      return {
        ...state,
        hasOverdue: action.payload.hasOverdue,
        isLoading: false,
        error: null,
        lastFetched: Date.now(),
      }
    case FETCH_OVERDUE_STATUS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      }
    case SET_OVERDUE_CACHE:
      return {
        ...state,
        hasOverdue: action.payload.hasOverdue,
        lastFetched: action.payload.timestamp,
      }
    default:
      return state
  }
}

export const overdueActionsSelectors = {
  getHasOverdue: (state: any) => state.overdueActions?.hasOverdue || false,
  getIsLoading: (state: any) => state.overdueActions?.isLoading || false,
  getError: (state: any) => state.overdueActions?.error,
  getLastFetched: (state: any) => state.overdueActions?.lastFetched,
  shouldRefresh: (state: any, maxAge = 5 * 60 * 1000) => {
    const lastFetched = state.overdueActions?.lastFetched
    if (!lastFetched) return true
    return Date.now() - lastFetched > maxAge
  },
}

function* fetchOverdueStatusSaga(action: any) {
  try {
    const { orgId } = action.payload
    const response = yield call(restClientInstance, 'CUSTOM_GET', 'events', {
      url: 'overdue_actions_status/',
    })
    yield put(fetchOverdueStatusSuccess(response.data.has_overdue))
  } catch (error) {
    yield put(fetchOverdueStatusFailure(error))
  }
}

export function* overdueActionsSaga() {
  yield takeEvery(FETCH_OVERDUE_STATUS, fetchOverdueStatusSaga)
}
